import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { PresignService } from '../../../services/presign.service';

@Component({
  selector: 'app-upload-quotation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './upload-quotation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadQuotationModalComponent { 
  
  @Output() close = new EventEmitter<void>();
  @Output() fileUploaded = new EventEmitter<File>();

  pdfFile: File | null = null;
  isUploading = false;

  constructor(private presign: PresignService) {}

  get pdfName() {
    return this.pdfFile?.name ?? null;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      const file = input.files[0];

      if (file.type !== 'application/pdf') {
        alert('Debe seleccionar un archivo PDF');
        return;
      }

      this.pdfFile = file;
      console.log('PDF seleccionado:', this.pdfFile.name);
    }
  }

  async uploadFile() {
    if (!this.pdfFile) {
      alert('Debe seleccionar un archivo para continuar');
      return;
    }

    const uuid = localStorage.getItem('uuid_cfdi');
    if (!uuid) {
      alert('No existe un UUID asociado. Suba antes una factura XML.');
      return;
    }

    this.isUploading = true;

    try {
      const folder = uuid;
      const filename = this.pdfFile.name;
      const bucket = 'ORD';

      const signedUrlResponse = await this.presign.getPresignedUrl(folder, filename, bucket);
      await this.presign.uploadFileToS3(signedUrlResponse.uploadUrl, this.pdfFile);

      this.fileUploaded.emit(this.pdfFile);
      this.close.emit();

    } catch (error) {
      console.error('Error al subir la cotización:', error);

    } finally {
      this.isUploading = false;
    }
  }
}
